export default class Rejoiner {
  handleRemove = ({ variantId, cartData }) => {
    const variantData = window.variantDataSelector.getData(variantId);

    window._rejoiner.push([
      'removeCartItem',
      {
        product_id: variantData.productId
      }
    ]);

    window._rejoiner.push([
      'setCartData',
      {
        cart_value: cartData.total_price,
        cart_item_count: cartData.item_count,
        promo: undefined,
        return_url: `https://ketone.com/a/secure/checkout/TcEMX8S96mnsh3Dtc5LO?cart_token=${cartData.token}`
      }
    ]);
  };

  handleChange = ({ cartData }) => {
    if (cartData.items.length === 0) return;

    window._rejoiner.push([
      'setCartData',
      {
        cart_value: cartData.total_price,
        cart_item_count: cartData.item_count,
        return_url: 'https://ketone.com/cart/'
      }
    ]);
    cartData.items.forEach((item) => {
      const { productDescription, productCollectionTitles } = window.variantDataSelector.getData(item.variant_id);

      window._rejoiner.push([
        'setCartItem',
        {
          product_id: item.variant_id,
          name: item.title,
          description: productDescription,
          price: item.price,
          product_url: `https://ketone.com/${item.url}`,
          item_qty: item.quantity,
          qty_price: item.line_price,
          image_url: item.image,
          // stock: item.variant?.inventory_quantity,
          category: JSON.parse(productCollectionTitles)
        }
      ]);
    });
  };

  subscribeToList = ({
    email, listId, firstName, variantId
  }) => {
    const params = {
      email,
      list_id: listId,
      fist_name: firstName
    };

    if (variantId) {
      params.variant_id = variantId;
    }

    window._rejoiner.push(['subscribeToList', params]);
  };
}
